import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=0f1370f2&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=ts"
export * from "./Rules.vue?vue&type=script&lang=ts"
import style0 from "./Rules.vue?vue&type=style&index=0&id=0f1370f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1370f2",
  null
  
)

export default component.exports